const mobileFeed = window.matchMedia('(max-width: 749px)');

// This rail uses native scrolling, not Instafeed's transform-based slider.
// Keep touch starts out of both vendor drag recognizers: they otherwise cancel
// the first part of a swipe and retain drag state after native pointercancel.
// Default pan/zoom and click events still reach the browser and app lightbox.
for (const type of ['touchstart', 'pointerdown']) {
  document.addEventListener(type, (event) => {
    if (
      mobileFeed.matches &&
      (event.type !== 'pointerdown' || event.pointerType === 'touch') &&
      event.target instanceof Element &&
      event.target.closest('.pp-community__app .instafeed-new-layout-container')
    ) {
      event.stopPropagation();
    }
  }, { capture: true, passive: true });
}
